/* eslint-disable new-parens */
import { State } from "../../model/application/state";
import { APIresponse } from "../../model/client/response";
import {
  AuditLog,
  BulkAirtime,
  MerchantBillers,
  MerchantCategories,
  MerchantComission,
  MerchantDashboard,
  MerchantProducts,
  MerchantProfile,
  MerchantRoles,
  MerchantUser,
  RegistrationPage,
  Transaction,
  UserAuthentication,
  UserValidation,
} from "../action/merchant";
import { GET, POST } from "../api/method";
import { store } from "../store";
import { ApiService } from "./../api/service";
import { Notify } from "./../../shared/component/notfication";
import { CatgoriesDetails } from "./../../view/merchant/billers/categories";
import { ProductCategoriesDetail } from "../../view/merchant/products/productCategories";
import {
  CommissionModel,
  ConvenienceFee,
  MaxCap,
  MerchantCommissionDetails,
  MinCap,
} from "../../view/merchant/merchantComission/commission";
import { permissionDetails } from "../../view/merchant/roles/permissions";
import { Role } from "../../view/merchant/manage users/user";
import { ImageType, ResponseCode } from "../../model/application/enum";
import {
  MerchantSetting,
  MerchantWallet,
  MerchantReport,
} from "../action/merchant";
import { APIrequest } from "../../model/client/request";
import { Encryption } from "../../shared/function/encryption";

export class MerchantThunkService {
  static CreateMerchant = async (state: State.RegistrationPage) => {
    const response = await POST(ApiService.merchant.create, state.request);
    if (response.success) {
      await this.userValidation();
      store.dispatch({
        type: RegistrationPage.Set_Registration_Page_State,
        payload: {
          ...state,
          processing: false,
          showAlert: true,
          isSuccess: true,
        },
      });
    } else {
      store.dispatch({
        type: RegistrationPage.Set_Registration_Page_State,
        payload: { ...state, processing: false, showAlert: false },
      });
      Notify(response.responseMessage as string, false);
    }
  };

  static userValidation = async (): Promise<APIresponse.ValidateUser> => {
    let merchant: APIresponse.ValidateUser = new APIresponse.ValidateUser();
    if (sessionStorage.getItem("***")) {
      let response = new APIresponse.API();
      if (sessionStorage.getItem("*******")) {
        merchant = JSON.parse(
          JSON.parse(
            Encryption.decrypt(sessionStorage.getItem("*******") as string)
          )
        );
        response.success = true;
        response.data = merchant;
        if (merchant.token === null) {
          response = await POST(
            `${localStorage.getItem("$$$")}${
              ApiService.sso.validateToken
            }${sessionStorage.getItem("***")?.toString().replace(/\s/g, "")}`,
            {}
          );
          merchant = response.data;
        }
      } else {
        response = await POST(
          `${localStorage.getItem("$$$")}${
            ApiService.sso.validateToken
          }${sessionStorage.getItem("***")?.toString().replace(/\s/g, "")}`,
          {}
        );
        merchant = response.data;
      }
      if (response.success) {
        sessionStorage.setItem("*****", merchant.token as string);
        sessionStorage.setItem(
          "*******",
          Encryption.encrypt(JSON.stringify(response.data))
        );
        return merchant;
      } else {
        window.location.href = localStorage.getItem("$$$$") ?? '';
      }
    } else {
      window.location.href = localStorage.getItem("$$$$") ?? '';
    }
    return merchant;
  };

  static ValidateUser = async (
    dispatch: any,
    state: State.RegistrationPage
  ) => {
    const merchant: APIresponse.ValidateUser =
      await MerchantThunkService.userValidation();
    state = {
      ...state,
      request: {
        firstName: merchant.firstName,
        lastName: merchant.lastName,
        phoneNumber: merchant.phoneNumber,
        email: merchant.email,
        ...state.request,
      },
    };

    store.dispatch({
      type: RegistrationPage.Set_Registration_Page_State,
      payload: { ...state, response: merchant },
    });
  };

  static ValidateLoggedInUser = async (
    dispatch: any,
    state: State.RegistrationPage
  ) => {
    const merchant: APIresponse.ValidateUser =
      await MerchantThunkService.GetLoggedInUser({} as any);
    state = {
      ...state,
    };
    store.dispatch({
      type: RegistrationPage.Set_Registration_Page_State,
      payload: { ...state, response: merchant },
    });
  };

  static AuthenticateUser = async (state: State.UserValidation) => {
    const merchantPortalDomain = localStorage.getItem("$$$$") ?? ''
    const merchantRegistrationUrl = `${merchantPortalDomain}/merchant-registration`
    
    let merchant: APIresponse.ValidateUser = new APIresponse.ValidateUser();
    let response = new APIresponse.API();

    if (state.token && state.token?.length > 0) {
      response = await POST(
        `${localStorage.getItem("$$$")}${
          ApiService.sso.validateToken + state.token
        }`,
        {},
      );
      
      if (response.success) {
        merchant = response.data;

        sessionStorage.setItem("*****", merchant.token as string);
        sessionStorage.setItem("***", state.token);
        sessionStorage.setItem(
          "*******",
          Encryption.encrypt(JSON.stringify(merchant))
        );

        // navigate user if user is registered or not
        if (merchant.registeredUser) {
          // save user logged in state
          store.dispatch({
            type: UserAuthentication.SET_USER_AUTHENTICATION,
            payload: {
              ...state,
              isProcessing: false,
              isValidated: true,
              response: merchant,
            },
          });
          
          // navigate to dashboard
          window.location.href = "/dashboard";
        } else {
          // update state
          store.dispatch({
            type: UserAuthentication.SET_USER_AUTHENTICATION,
            payload: {
              ...state,
              isProcessing: false,
              isValidated: false,
            },
          });

          // navigate to merchant portal
          window.location.href = merchantRegistrationUrl
        }
      } else {
        // check error response code
        if (response.responseCode === ResponseCode.INVALID_TOKEN) {
          window.location.href = merchantRegistrationUrl;
        } else {
          // show error notification
          Notify(
            response.responseMessage ?? "Authentication failed. Please try again shortly.",
            false
          );
        }
        
        // update state
        store.dispatch({
          type: UserAuthentication.SET_USER_AUTHENTICATION,
          payload: {
            ...state,
            isProcessing: false,
            isValidated: false,
          },
        });
      }
    } else {
      setTimeout(() => {
        // update state
        store.dispatch({
          type: UserAuthentication.SET_USER_AUTHENTICATION,
          payload: {
            ...state,
            isProcessing: false,
            isValidated: false,
          },
        });
      }, 1);
    }
    return merchant;
  };

  static DashboardTop10 = async (state: State.DashboardState) => {
    if (sessionStorage.getItem("*****")) {
      const response = await POST(
        `${ApiService.dashboard.top10}`,
        {},
        sessionStorage.getItem("*****")
      );
      const merchant: APIresponse.Top10Transactions = response.data;
      let sn = 0;
      merchant.transactionDTOS.forEach((element) => {
        sn = sn + 1;
        element.key = sn;
      });
      if (response.success) {
        store.dispatch({
          type: MerchantDashboard.Set_Merchant_Dashboard_State,
          payload: {
            ...state,
            dashboardTable: merchant,
            processing: false,
          },
        });
      } else {
        store.dispatch({
          type: MerchantDashboard.Set_Merchant_Dashboard_State,
          payload: {
            ...state,
            processing: false,
          },
        });
      }
    }
  };

  static DashboardStatistics = async (state: State.DashboardState) => {
    if (sessionStorage.getItem("*****")) {
      const response = await POST(
        `${ApiService.dashboard.statistics + state.day}`,
        {},
        sessionStorage.getItem("*****")
      );
      const merchants: APIresponse.Statistics = response.data;
      const user = await this.GetLoggedInUser({} as any);
      if (response.success) {
        this.DashboardTop10({
          ...state,
          dashboardStatistics: merchants,
          processing: false,
          response: user,
        });
      } else {
        store.dispatch({
          type: MerchantDashboard.Set_Merchant_Dashboard_State,
          payload: {
            ...state,
            processing: false,
            key: "3",
          },
        });
      }
    }
  };

  static GetBalance = async (state: State.DashboardState) => {
    let response = new APIresponse.API();
    response = await POST(
      `${ApiService.dashboard.balances}`,
      {},
      sessionStorage.getItem("*****")
    );
    const merchant: APIresponse.Balances = response.data;
    if (response.success) {
      store.dispatch({
        type: MerchantDashboard.Set_Merchant_Dashboard_State,
        payload: {
          ...state,
          dasboardBalance: merchant,
        },
      });
    } else {
      store.dispatch({
        type: MerchantDashboard.Set_Merchant_Dashboard_State,
        payload: {
          ...state,
        },
      });
    }
  };

  static GetCategory = async (state: State.ManageCategory) => {
    if (sessionStorage.getItem("*****")) {
      const response = await POST(
        `${ApiService.category.getCategory}`,
        {
          size: 100,
          page: 0,
        },
        sessionStorage.getItem("*****")
      );
      const merchant: Array<APIresponse.CategoryDTO> =
        response.data?.categoryDTOList;
      if (response.success) {
        let sn = 0;
        merchant?.forEach((element) => {
          sn = sn + 1;
          element.key = sn;
        });

        store.dispatch({
          type: MerchantCategories.Set_Merchant_Category_State,
          payload: {
            ...state,
            response: merchant,
            processing: false,
            originalResponse: merchant,
          },
        });
      } else {
        store.dispatch({
          type: MerchantCategories.Set_Merchant_Category_State,
          payload: {
            ...state,
            processing: false,
          },
        });
      }
    }
  };

  static GetAllBiller = async (state: State.MerchantBiller) => {
    if (sessionStorage.getItem("*****")) {
      const response = await POST(
        `${ApiService.biller.getAllBillers}`,
        {
          size: 100,
          page: 0,
        },
        sessionStorage.getItem("*****")
      );
      const merchant: Array<APIresponse.MerchantBiller> =
        response.data?.billerDTOList;
      if (response.success) {
        const excludedBillers = await this.GetExcludedBiller({} as any);
        store.dispatch({
          type: MerchantBillers.Set_Merchant_Biller_State,
          payload: {
            ...state,
            processing: false,
            excludedBillers,
            allBiller: {
              ...state.allBiller,
              responses: merchant,
            },
          },
        });
      } else {
        store.dispatch({
          type: MerchantBillers.Set_Merchant_Biller_State,
          payload: {
            ...state,
            processing: false,
          },
        });
      }
      return merchant;
    }
  };

  static GetExcludedBiller = async (state: State.MerchantBiller) => {
    if (sessionStorage.getItem("*****")) {
      const response = await POST(
        `${ApiService.biller.getMerchantBillers}`,
        {
          size: 100,
          page: 0,
        },
        sessionStorage.getItem("*****")
      );
      const merchant: Array<APIresponse.ExcludedBiller> =
        response.data?.billers;
      if (response.success) {
        store.dispatch({
          type: MerchantBillers.Set_Merchant_Biller_State,
          payload: {
            ...state,
            excludedBillers: merchant,
          },
        });
      } else {
        store.dispatch({
          type: MerchantBillers.Set_Merchant_Biller_State,
          payload: {
            ...state,
          },
        });
      }
      return merchant;
    }
  };

  static GetBiller = async (state: State.MerchantBiller) => {
    if (sessionStorage.getItem("*****")) {
      const response = await POST(
        `${ApiService.biller.getBiller}`,
        {
          size: 100,
          page: 0,
        },
        sessionStorage.getItem("*****")
      );
      let merchant: Array<APIresponse.MerchantBiller> =
        response.data?.billerDTOList;
      if (response.success || response.responseCode === "88") {
        if (!Array.isArray(merchant)) {
          merchant = new Array<APIresponse.MerchantBiller>();
        }
        merchant?.forEach((element) => {
          element.categories = CatgoriesDetails(element.categoryDTOS);
        });

        let sn = 0;
        merchant?.forEach((element) => {
          sn = sn + 1;
          element.key = sn;
        });

        this.GetAllBiller({
          ...state,
          response: merchant,
          processing: false,
          originalResponse: merchant,
        });
      } else {
        store.dispatch({
          type: MerchantBillers.Set_Merchant_Biller_State,
          payload: {
            ...state,
            processing: false,
          },
        });
      }
    }
  };

  static AddMoreBillers = async (state: State.MerchantBiller) => {
    if (sessionStorage.getItem("*****")) {
      const response = await POST(
        `${ApiService.biller.saveBiller}`,
        state.request,
        sessionStorage.getItem("*****")
      );
      if (response.success) {
        MerchantThunkService.GetBiller({
          ...state,
          request: {},
          processing: false,
        });
        Notify(response.responseMessage as string, true);
      } else {
        store.dispatch({
          type: MerchantBillers.Set_Merchant_Biller_State,
          payload: {
            ...state,
            processing: false,
          },
        });
        Notify(response.responseMessage as string, false);
      }
    }
  };

  static GetMerchantCommission = async (state: State.MerchantCommission) => {
    if (sessionStorage.getItem("*****")) {
      const response = await POST(
        `${ApiService.merchantCommission.getmerchantcommission}`,
        {
          size: 100,
          page: 0,
        },
        sessionStorage.getItem("*****")
      );
      const merchant: Array<APIresponse.MerchantCommission> =
        response.data?.merchantCommissionDTOS;
      if (response.success) {
        merchant?.forEach((element) => {
          element.commissions = MerchantCommissionDetails(
            element.commissionDTO
          );
          element.commissionModel = CommissionModel(element.commissionDTO);
          element.minCap = MinCap(element.commissionDTO);
          element.maxCap = MaxCap(element.commissionDTO);
          element.convenienceFee = ConvenienceFee(element.commissionDTO);
        });
        let sn = 0;
        merchant?.forEach((element) => {
          sn = sn + 1;
          element.key = sn;
        });
        store.dispatch({
          type: MerchantComission.Set_Merchant_Commission_State,
          payload: {
            ...state,
            response: merchant,
            processing: false,
            originalResponse: merchant,
          },
        });
      } else {
        store.dispatch({
          type: MerchantComission.Set_Merchant_Commission_State,
          payload: {
            ...state,
            processing: false,
          },
        });
      }
    }
  };

  static GetProduct = async (state: State.MerchantProduct) => {
    if (sessionStorage.getItem("*****")) {
      const response = await POST(
        `${ApiService.product.getProduct}`,
        {
          size: state.pageSize,
          page: state.page,
        },
        sessionStorage.getItem("*****")
      );
      const merchant: Array<APIresponse.MerchantProducts> =
        response.data?.productDTOList;
      if (response.success) {
        merchant?.forEach((element) => {
          element.category = ProductCategoriesDetail(element.categoryDTO);
        });
        let sn = state.page * state.pageSize;
        merchant?.forEach((element) => {
          sn = sn + 1;
          element.key = sn;
        });
        store.dispatch({
          type: MerchantProducts.Set_Merchant_Product_State,
          payload: {
            ...state,
            response: merchant,
            processing: false,
            total: response.data?.totalCount,
            originalResponse: merchant,
          },
        });
      } else {
        store.dispatch({
          type: MerchantProducts.Set_Merchant_Product_State,
          payload: {
            ...state,
            processing: false,
          },
        });
      }
    }
  };

  static GetPermissions = async (state: State.MerchantRole) => {
    if (sessionStorage.getItem("*****")) {
      const response = await POST(
        `${ApiService.permissions.getPermissions}`,
        {
          size: 100,
          page: 0,
        },
        sessionStorage.getItem("*****")
      );
      const merchant: Array<APIresponse.Permission> =
        response.data?.permissions;
      merchant?.forEach((element) => {
        element.checked = state.roleDetails?.permissions
          ?.map((x) => x.name)
          .includes(element.name);
      });
      if (response.success) {
        store.dispatch({
          type: MerchantRoles.Set_Merchant_Role_State,
          payload: {
            ...state,
            request: {
              ...state.request,
              name: state.roleDetails?.name,
              permissionNames: state.roleDetails?.permissions?.map(
                (x) => x.name
              ),
            },
            permissions: {
              ...state.permissions,
              response: merchant,
            },
          },
        });
      }
    }
  };

  static CreateRoles = async (state: State.MerchantRole) => {
    let response = new APIresponse.API();
    switch (state.action) {
      case "edit":
        response = await POST(
          ApiService.roles.updateRole + state.roleDetails.id,
          state.request,
          sessionStorage.getItem("*****")
        );
        break;
      case "create":
        response = await POST(
          ApiService.roles.createRole,
          state.request,
          sessionStorage.getItem("*****")
        );
        break;
      default:
        response = await POST(
          ApiService.roles.deleteRole + state.roleDetails.id,
          state.request,
          sessionStorage.getItem("*****")
        );
        break;
    }
    if (response.success) {
      MerchantThunkService.GetRoles(() => {}, {
        ...state,
        processing: false,
        showAlert: true,
        isSuccess: true,
        request: {},
      });
      Notify(response.responseMessage as string, true);
    } else {
      store.dispatch({
        type: MerchantRoles.Set_Merchant_Role_State,
        payload: { ...state, processing: false, showAlert: false },
      });
      Notify(response.responseMessage as string, false);
    }
  };

  static GetRoles = async (dispatch: any = {}, state: State.MerchantRole) => {
    if (sessionStorage.getItem("*****")) {
      const response = await POST(
        `${ApiService.roles.getRoles}`,
        {
          size: 100,
          page: 0,
        },
        sessionStorage.getItem("*****")
      );
      const merchant: Array<APIresponse.Role> = response.data?.roles;
      if (response.success) {
        merchant?.forEach((element) => {
          element.permission = permissionDetails(element.permissions);
        });
        let sn = 0;
        merchant?.forEach((element) => {
          sn = sn + 1;
          element.key = sn;
        });
        store.dispatch({
          type: MerchantRoles.Set_Merchant_Role_State,
          payload: {
            ...state,
            response: merchant,
            processing: false,
            originalResponse: merchant,
          },
        });
      } else {
        store.dispatch({
          type: MerchantRoles.Set_Merchant_Role_State,
          payload: {
            ...state,
            processing: false,
          },
        });
      }
      return merchant;
    } else {
      return [];
    }
  };

  static GetUser = async (state: State.MerchantUsers) => {
    const response = await POST(
      `${ApiService.users.getUser}`,
      {
        size: 100,
        page: 0,
      },
      sessionStorage.getItem("*****")
    );
    const merchant: Array<APIresponse.MerchantUser> = response.data?.users;
    const roles = await this.GetRoles(() => {}, {} as any);
    if (response.success) {
      merchant?.forEach((element) => {
        element.roleName = Role(element.role);
      });
      let sn = 0;
      merchant?.forEach((element) => {
        sn = sn + 1;
        element.key = sn;
      });
      store.dispatch({
        type: MerchantUser.Set_Merchant_User_State,
        payload: {
          ...state,
          response: merchant,
          processing: false,
          originalResponse: merchant,
          role: {
            ...state.role,
            response: roles,
          },
        },
      });
    } else {
      store.dispatch({
        type: MerchantUser.Set_Merchant_User_State,
        payload: {
          ...state,
          processing: false,
        },
      });
    }
  };

  static GetLoggedInUser = async (state: State.UserValidation) => {
    const response = await POST(
      `${ApiService.users.getLoggedInUser}`,
      {},
      sessionStorage.getItem("*****")
    );
    if (response.success) {
      const merchant: APIresponse.ValidateUser = response.data;
      store.dispatch({
        type: RegistrationPage.Set_Registration_Page_State,
        payload: {
          ...state,
          response: merchant,
        },
      });
    } else {
      store.dispatch({
        type: UserValidation.Set_User_Validation_State,
        payload: {
          ...state,
          processing: false,
        },
      });
    }
    return response.data;
  };

  static CreateUser = async (state: State.MerchantUsers) => {
    let response = new APIresponse.API();

    switch (state.action) {
      case "edit":
        response = await POST(
          ApiService.users.updateUsers + state.userDetails.id,
          state.request,
          sessionStorage.getItem("*****")
        );
        break;
      case "create":
        response = await POST(
          ApiService.users.createUsers,
          state.request,
          sessionStorage.getItem("*****")
        );
        break;
      default:
        response = await POST(
          ApiService.users.toggleUserStatus + state.userDetails.id,
          state.request,
          sessionStorage.getItem("*****")
        );
        break;
    }
    if (response.success) {
      MerchantThunkService.GetUser({
        ...state,
        processing: false,
        showAlert: true,
        isSuccess: true,
        request: {},
        isUpdate: false,
      });
      Notify(response.responseMessage as string, true);
    } else {
      if (response.responseCode === ResponseCode.CLIENT_NOT_ALLOWED) {
        window.location.href = "/access-denied";
      } else {
        store.dispatch({
          type: MerchantUser.Set_Merchant_User_State,
          payload: { ...state, processing: false, showAlert: false },
        });
        Notify(response.responseMessage as string, false);
      }
    }
  };

  static GetKey = async (state: State.MerchantSettings) => {
    let response = new APIresponse.API();
    switch (state.action) {
      case "reset":
        response = await POST(
          ApiService.settings.resetKeys,
          {},
          sessionStorage.getItem("*****")
        );
        break;
      default:
        response = await POST(
          ApiService.settings.getKeys,
          {},
          sessionStorage.getItem("*****")
        );
        break;
    }
    if (response.success) {
      const merchant: APIresponse.Settings = response.data;
      store.dispatch({
        type: MerchantSetting.Set_Merchant_KeySettings_State,
        payload: {
          ...state,
          response: merchant,
          processing: false,
        },
      });
    } else {
      store.dispatch({
        type: MerchantSetting.Set_Merchant_KeySettings_State,
        payload: {
          ...state,
          processing: false,
        },
      });
    }
  };

  static GetUsers = async () => {
    const response = await POST(
      `${ApiService.users?.getUser}`,
      {
        page: 0,
        size: 100,
      },
      sessionStorage.getItem("*****")
    );
    return response.data?.users as Array<APIresponse.MerchantUser>;
  };

  static ViewWalletLimit = async (
    dispatch: any,
    state: State.MerchantSettings
  ) => {
    const response = await POST(
      `${ApiService.settings.viewWalletLimit}`,
      {
        size: 100,
        page: 0,
      },
      sessionStorage.getItem("*****")
    );
    const merchant: APIresponse.WalletAlertResponse = response.data;
    if (response.success) {
      const user: Array<APIresponse.MerchantUser> = await this.GetUsers();
      store.dispatch({
        type: MerchantSetting.Set_Merchant_KeySettings_State,
        payload: {
          ...state,
          walletAlert: merchant,
          processing: false,
          merchantUser: user,
        },
      });
    } else {
      store.dispatch({
        type: MerchantSetting.Set_Merchant_KeySettings_State,
        payload: {
          ...state,
          processing: false,
        },
      });
    }
  };

  static UpdateWalletAlert = async (
    dispatch: any,
    state: State.MerchantSettings
  ) => {
    state.request = {
      ...state.request,
      amount: parseInt(state.request?.amount as any),
    };
    const response = await POST(
      `${ApiService.settings.walletAlert}`,
      state.request,
      sessionStorage.getItem("*****")
    );
    if (response.success) {
      await this.ViewWalletLimit(dispatch, { ...state });
      Notify("Wallet Notification settings successful", true);
    } else {
      store.dispatch({
        type: MerchantSetting.Set_Merchant_KeySettings_State,
        payload: {
          ...state,
          processing: false,
        },
      });
      Notify(response.responseMessage as string, false);
    }
  };

  static GetWallet = async (state: State.Wallet) => {
    const response = await POST(
      `${ApiService.wallet.getWalletTransactions}`,
      {
        size: 100,
        page: 0,
      },
      sessionStorage.getItem("*****")
    );
    const merchant: APIresponse.WalletTransaction = response.data;
    let sn = 0;
    merchant?.walletTransactionDTOS?.forEach((element) => {
      sn = sn + 1;
      element.key = sn;
    });
    if (response.success) {
      store.dispatch({
        type: MerchantWallet.Set_Merchant_WalletTransaction_State,
        payload: {
          ...state,
          merchantWalletTransaction: merchant,
          originalResponse: merchant.walletTransactionDTOS,
          processing: false,
        },
      });
    } else {
      store.dispatch({
        type: MerchantWallet.Set_Merchant_WalletTransaction_State,
        payload: {
          ...state,
          processing: false,
        },
      });
    }
  };

  static GetWalletCommission = async (state: State.Wallet) => {
    const response = await POST(
      `${ApiService.wallet.getWalletCommission}`,
      {
        size: 100,
        page: 0,
      },
      sessionStorage.getItem("*****")
    );
    const merchant: APIresponse.WalletCommission = response.data;
    if (response.success) {
      let sn = 0;
      merchant.commissionTransactionDTOS?.forEach((element) => {
        sn = sn + 1;
        element.key = sn;
      });
      if (response.success) {
        store.dispatch({
          type: MerchantWallet.Set_Merchant_WalletTransaction_State,
          payload: {
            ...state,
            merchantWalletCommission: merchant,
            walletcommissionOriginalResponse:
              merchant.commissionTransactionDTOS,
            processing: false,
          },
        });
      } else {
        store.dispatch({
          type: MerchantWallet.Set_Merchant_WalletTransaction_State,
          payload: {
            ...state,
            processing: false,
          },
        });
      }
    }
  };

  static GetDashboardBalance = async (state: State.Wallet) => {
    const response = await POST(
      `${ApiService.dashboard.balances}`,
      {},
      sessionStorage.getItem("*****")
    );
    const merchant: APIresponse.Balances = response.data;
    if (response.success) {
      this.GetWallet({
        ...state,
        merchantDashboard: merchant,
        processing: false,
      });
    }
  };

  static GetReport = async (state: State.MerchantReports) => {
    const response = await POST(
      `${ApiService.reports.getReports}`,
      {
        size: 100,
        page: state.page,
      },
      sessionStorage.getItem("*****")
    );
    const merchant: Array<APIresponse.Report> = response.data?.transactionDTOS;
    if (response.success) {
      let sn = 0;
      merchant?.forEach((element) => {
        sn = sn + 1;
        element.key = sn;
      });

      store.dispatch({
        type: MerchantReport.Set_Merchant_Report_State,
        payload: {
          ...state,
          response: merchant,
          processing: false,
          originalResponse: merchant,
          total: response.data?.totalCount,
        },
      });
    } else {
      store.dispatch({
        type: MerchantReport.Set_Merchant_Report_State,
        payload: {
          ...state,
          processing: false,
        },
      });
    }
  };

  static GetMerchantSettlement = async (state: State.MerchantReports) => {
    const response = await POST(
      `${ApiService.reports.getMerchantSettlement}`,
      {
        size: 100,
        page: state.page,
      },
      sessionStorage.getItem("*****")
    );
    const merchant: Array<APIresponse.Report> =
      response.data?.settlementReportDTOS;
    if (response.success) {
      let sn = 0;
      merchant?.forEach((element) => {
        sn = sn + 1;
        element.key = sn;
      });

      store.dispatch({
        type: MerchantReport.Set_Merchant_Report_State,
        payload: {
          ...state,
          merchantSettlements: merchant,
          processing: false,
          originalMerchantSettlements: merchant,
          settlementTotal: response.data?.totalCount,
        },
      });
    } else {
      store.dispatch({
        type: MerchantReport.Set_Merchant_Report_State,
        payload: {
          ...state,
          processing: false,
        },
      });
    }
  };

  static GetReceipt = async (state: State.MerchantReports) => {
    const user = await this.GetLoggedInUser({} as any);
    const response = await POST(
      `${ApiService.reports.receipt}${state.requestId}`,
      {},
      sessionStorage.getItem("*****")
    );
    const merchant = response;
    if (response.success) {
      store.dispatch({
        type: MerchantReport.Set_Merchant_Report_State,
        payload: {
          ...state,
          showReceipt: true,
          title: "Transaction Successful",
          transactionDate: merchant.transactionDateTime,
          message: merchant.responseMessage,
          lookUpResponse: merchant,
          receipt: merchant.data,
          user,
          isSuccessful: true,
        },
      });
    } else {
      store.dispatch({
        type: MerchantReport.Set_Merchant_Report_State,
        payload: {
          ...state,
          showReceipt: true,
          title: "Transaction Failed",
          transactionDate: response.transactionDateTime,
          message: response.responseMessage,
          lookUpResponse: response,
          user,
          isSuccessful: false,
        },
      });
    }
  };

  static FilterReport = async (state: State.MerchantReports) => {
    const response = await POST(
      `${ApiService.reports.reportSearch}?download=${state.isDownload}`,
      state.filterRequest,
      sessionStorage.getItem("*****")
    );
    if (response.success) {
      const merchant: APIresponse.Top10Transactions = response.data;
      let sn = 0;
      merchant?.transactionDTOS?.forEach((element) => {
        sn = sn + 1;
        element.key = sn;
      });
      store.dispatch({
        type: MerchantReport.Set_Merchant_Report_State,
        payload: {
          ...state,
          response: merchant?.transactionDTOS,
          processing: false,
          showModal: false,
          isDownload: false,
          filterRequest: new APIrequest.ReportSearch(),
        },
      });
      Notify(response.responseMessage as string, true);
    } else {
      store.dispatch({
        type: MerchantReport.Set_Merchant_Report_State,
        payload: {
          ...state,
          processing: false,
        },
      });
      Notify(response.responseMessage as string, false);
    }
  };

  static FilterSettlement = async (state: State.MerchantReports) => {
    const response = await POST(
      `${ApiService.reports.settlementSearch}?download=${state.isDownload}`,
      state.filterSettlementRequest,
      sessionStorage.getItem("*****")
    );
    if (response.success) {
      const merchant: Array<APIresponse.MerchantSettlements> =
        response.data?.settlementReportDTOS;
      let sn = 0;
      merchant?.forEach((element) => {
        sn = sn + 1;
        element.key = sn;
      });
      store.dispatch({
        type: MerchantReport.Set_Merchant_Report_State,
        payload: {
          ...state,
          merchantSettlements: merchant,
          processing: false,
          showModal: false,
          isDownload: false,
          filterSettlementRequest: new APIrequest.SettlementSearch(),
        },
      });
      Notify(response.responseMessage as string, true);
    } else {
      store.dispatch({
        type: MerchantReport.Set_Merchant_Report_State,
        payload: {
          ...state,
          processing: false,
        },
      });
      Notify(response.responseMessage as string, false);
    }
  };

  static SendDailyReports = async (state: State.MerchantReports) => {
    const response = await GET(`${ApiService.dailyReport}${state.date}`);
    if (response.success) {
      store.dispatch({
        type: MerchantReport.Set_Merchant_Report_State,
        payload: {
          ...state,
          processing: false,
          date: "",
        },
      });
      Notify(response.responseMessage as string, true);
    } else {
      store.dispatch({
        type: MerchantReport.Set_Merchant_Report_State,
        payload: {
          ...state,
          processing: false,
          date: "",
        },
      });
      Notify(response.responseMessage as string, false);
    }
  };

  static FilterWallet = async (state: State.Wallet) => {
    const response = await POST(
      `${ApiService.wallet.walletSearch}?download=${state.isDownload}`,
      state.filterRequest,
      sessionStorage.getItem("*****")
    );
    if (response.success) {
      const merchant: APIresponse.WalletTransaction = response.data;
      let sn = 0;
      merchant?.walletTransactionDTOS?.forEach((element) => {
        sn = sn + 1;
        element.key = sn;
      });
      store.dispatch({
        type: MerchantWallet.Set_Merchant_WalletTransaction_State,
        payload: {
          ...state,
          merchantWalletTransaction: merchant,
          processing: false,
          showWalletModal: false,
          isDownload: false,
          filterRequest: new APIrequest.WalletSearch(),
        },
      });
      Notify(response.responseMessage as string, true);
    } else {
      store.dispatch({
        type: MerchantWallet.Set_Merchant_WalletTransaction_State,
        payload: {
          ...state,
          processing: false,
        },
      });
      Notify(response.responseMessage as string, false);
    }
  };

  static FilterWalletCommission = async (state: State.Wallet) => {
    const response = await POST(
      `${ApiService.wallet.walletCommissionSearch}?download=${state.isDownload}`,
      state.filterRequest,
      sessionStorage.getItem("*****")
    );
    if (response.success) {
      const merchant: APIresponse.WalletCommission = response.data;
      let sn = 0;
      merchant?.commissionTransactionDTOS?.forEach((element) => {
        sn = sn + 1;
        element.key = sn;
      });
      store.dispatch({
        type: MerchantWallet.Set_Merchant_WalletTransaction_State,
        payload: {
          ...state,
          merchantWalletCommission: merchant,
          processing: false,
          showWalletCommissionModal: false,
          isDownload: false,
          filterRequest: new APIrequest.WalletSearch(),
        },
      });
      Notify(response.responseMessage as string, true);
    } else {
      store.dispatch({
        type: MerchantWallet.Set_Merchant_WalletTransaction_State,
        payload: {
          ...state,
          processing: false,
        },
      });
      Notify(response.responseMessage as string, false);
    }
  };

  static TransferCommission = async (state: State.Wallet) => {
    const response = await POST(
      `${ApiService.wallet.commissionTransfer}`,
      {},
      sessionStorage.getItem("*****")
    );
    const merchant: APIresponse.CommissionTransfer = response.data;
    if (response.success) {
      await this.GetDashboardBalance({
        ...state,
        merchantDashboard: {
          ...state.merchantDashboard,
          commissionBalance: 0,
        },
        TransferCommission: merchant,
        processing: false,
      });
      Notify(response.responseMessage as string, true);
    } else {
      store.dispatch({
        type: MerchantWallet.Set_Merchant_WalletTransaction_State,
        payload: {
          ...state,
          processing: false,
        },
      });
      Notify(response.responseMessage as string, false);
    }
  };

  static AuditLogs = async (state: State.MerchantAuditLogs) => {
    const response = await POST(
      `${ApiService.auditLog.getAuditLog}`,
      {
        page: 0,
        size: 100,
      },
      sessionStorage.getItem("*****")
    );

    const merchant: Array<APIresponse.AuditLog> = response.data?.auditLogs;
    if (response.success) {
      let sn = 0;
      merchant?.forEach((element) => {
        sn = sn + 1;
        element.key = sn;
      });
      store.dispatch({
        type: AuditLog.Set_Audit_Logs,
        payload: {
          ...state,
          processing: false,
          response: merchant,
          originalResponse: merchant,
        },
      });
    } else {
      store.dispatch({
        type: AuditLog.Set_Audit_Logs,
        payload: {
          ...state,
          processing: false,
        },
      });
    }
  };

  static FilterAuditLog = async (state: State.MerchantAuditLogs) => {
    const response = await POST(
      `${ApiService.auditLog.auditLogSearch}?download=${state.isDownload}`,
      state.filterRequests,
      sessionStorage.getItem("*****")
    );
    if (response.success) {
      const merchant: Array<APIresponse.AuditLog> = response.data?.auditLogs;
      let sn = 0;
      merchant?.forEach((element) => {
        sn = sn + 1;
        element.key = sn;
      });
      store.dispatch({
        type: AuditLog.Set_Audit_Logs,
        payload: {
          ...state,
          response: merchant,
          processing: false,
          showModal: false,
          isDownload: false,
          filterRequests: new APIrequest.AuditLogSearch(),
        },
      });
      Notify(response.responseMessage as string, true);
    } else {
      store.dispatch({
        type: AuditLog.Set_Audit_Logs,
        payload: {
          ...state,
          processing: false,
        },
      });
      Notify(response.responseMessage as string, false);
    }
  };

  static GetKycTier = async (state: State.MerchantProfile) => {
    const response = await POST(
      `${ApiService.kycTier.getKycTier}`,
      {
        page: 0,
        size: 100,
      },
      sessionStorage.getItem("*****")
    );
    const kycTier: Array<APIresponse.KYCTiers> = response.data.tiers;
    if (response.success) {
      store.dispatch({
        type: MerchantProfile.SET_MERCHANT_PROFILE_STATE,
        payload: {
          ...state,
          kycTier: {
            ...state.kycTier,
            response: kycTier,
            processing: false,
          },
        },
      });
    } else {
      store.dispatch({
        type: MerchantProfile.SET_MERCHANT_PROFILE_STATE,
        payload: {
          ...state,
          kycTier: {
            ...state.kycTier,
            processing: false,
          },
        },
      });
    }
    return kycTier;
  };

  static UpdateMerchantProfile = async (state: State.MerchantProfile) => {
    const response = await POST(
      `${ApiService.profile.updateProfile}`,
      state.request,
      sessionStorage.getItem("*****")
    );
    let merchants: APIresponse.ValidateUser = response.data;
    if (response.success) {
      store.dispatch({
        type: MerchantProfile.SET_MERCHANT_PROFILE_STATE,
        payload: {
          ...state,
          processing: false,
          isSuccess: true,
          saveAlert: false,
          current: state.current + 1,
          details: merchants,
          status: "finish",
        },
      });
      Notify(response.responseMessage as string, true);
    } else {
      store.dispatch({
        type: MerchantProfile.SET_MERCHANT_PROFILE_STATE,
        payload: {
          ...state,
          processing: false,
          showAlert: false,
          saveAlert: false,
        },
      });
      Notify(response.responseMessage as string, false);
    }
  };

  static GetMerchantProfile = async (state: State.MerchantProfile) => {
    let response: any = await this.GetLoggedInUser({} as any);
    let fileList = new State.FileList();
    fileList.uid = response.merchant?.merchantKYC?.id?.toString();
    let KycFileList = new State.KycFileList();
    if (response.merchant?.merchantKYC) {
      KycFileList.cac2AndCac7 =
        response.merchant.merchantKYC.cac2AndCac7 === null
          ? (null as any)
          : [
              {
                ...fileList,
                name: ImageType.CAC2_AND_CAC7,
                url: response.merchant?.merchantKYC?.cac2AndCac7,
              },
            ];
      KycFileList.boardResolutionApproval =
        response.merchant.merchantKYC.boardResolutionApproval === null
          ? (null as any)
          : [
              {
                ...fileList,
                name: ImageType.BOARD_RESOLUTION_APPROVAL,
                url: response.merchant?.merchantKYC?.boardResolutionApproval,
              },
            ];
      KycFileList.certificateOfIncorporation =
        response.merchant.merchantKYC.certificateOfIncorporation === null
          ? (null as any)
          : [
              {
                ...fileList,
                name: ImageType.CERTIFICATE_OF_INCORPORATION,
                url: response.merchant?.merchantKYC?.certificateOfIncorporation,
              },
            ];
      KycFileList.directorValidIdCard =
        response.merchant.merchantKYC.directorValidIdCard === null
          ? (null as any)
          : [
              {
                ...fileList,
                name: ImageType.DIRECTOR_VALID_ID_CARD,
                url: response.merchant?.merchantKYC?.directorValidIdCard,
              },
            ];
      KycFileList.gazette =
        response.merchant.merchantKYC.gazette === null
          ? (null as any)
          : [
              {
                ...fileList,
                name: ImageType.GAZETTE,
                url: response.merchant?.merchantKYC?.gazette,
              },
            ];
      KycFileList.governmentIssuedIdCard =
        response.merchant.merchantKYC.governmentIssuedIdCard === null
          ? (null as any)
          : [
              {
                ...fileList,
                name: ImageType.GOVERNMENT_ISSUED_ID_CARD,
                url: response.merchant?.merchantKYC?.governmentIssuedIdCard,
              },
            ];
      KycFileList.memart =
        response.merchant.merchantKYC.memart === null
          ? (null as any)
          : [
              {
                ...fileList,
                name: ImageType.MEMART,
                url: response.merchant?.merchantKYC?.memart,
              },
            ];
      KycFileList.utilityBill =
        response.merchant.merchantKYC.utilityBill === null
          ? (null as any)
          : [
              {
                ...fileList,
                name: ImageType.UTILITY_BILL,
                url: response.merchant?.merchantKYC?.utilityBill,
              },
            ];
    }
    state = {
      ...state,
      fileList: KycFileList,
      request: {
        ...state.request,
        businessName: response.merchant?.name,
        businessAddress: response.merchant?.address,
        businessPhoneNumber: response.merchant?.phoneNumber,
        businessEmail: response.merchant?.email,
        firstName: response.firstName,
        lastName: response.lastName,
        kycTierId: response.merchant?.kycTierDTO?.id,
        rcNo: response.merchant?.rcNo,
        email: response.email,
        phoneNumber: response.phoneNumber,
      },
      UploadKycRequest: {
        ...state.UploadKycRequest,
        emailAddress: response.merchant?.merchantKYC?.emailAddress,
        homeAddress: response.merchant?.merchantKYC?.homeAddress,
        fullName: response.merchant?.merchantKYC?.fullName,
        dateOfBirth: response.merchant?.merchantKYC?.dateOfBirth,
        placeOfBirth: response.merchant?.merchantKYC?.placeOfBirth,
        phoneNumber: response.phoneNumber,
        gender: response.merchant?.merchantKYC?.gender,
        bvn: response.merchant?.merchantKYC?.bvn,
        directorBvn: response.merchant?.merchantKYC?.directorBvn,
        directorName: response.merchant?.merchantKYC?.directorName,
      },
      current: 0,
    };

    store.dispatch({
      type: MerchantProfile.SET_MERCHANT_PROFILE_STATE,
      payload: {
        ...state,
        details: response,
        processing: false,
        showAlert: response.merchant?.merchantKYC?.kycStatus === "PENDING",
      },
    });
    return state;
  };

  static submitKyc = async (state: State.MerchantProfile) => {
    const response = await POST(
      `${ApiService.profile.kycForm}`,
      state.UploadKycRequest,
      sessionStorage.getItem("*****")
    );
    if (response.success) {
      MerchantThunkService.GetMerchantProfile({
        ...state,
      });
      store.dispatch({
        type: MerchantProfile.SET_MERCHANT_PROFILE_STATE,
        payload: {
          ...state,
          processing: false,
        },
      });
      Notify(response.responseMessage as string, true);
    } else {
      store.dispatch({
        type: MerchantProfile.SET_MERCHANT_PROFILE_STATE,
        payload: {
          ...state,
          processing: false,
        },
      });
      Notify(response.responseMessage as string, false);
    }
  };

  static GetTransactionCategory = async (state: State.MerchantTransaction) => {
    const response = await POST(
      `${ApiService.transaction.getTransactionCategory}`,
      {
        page: 0,
        size: 100,
      },
      sessionStorage.getItem("*****")
    );

    const merchant: Array<APIresponse.TransactionCategory> =
      response.data?.categoryDTOList;
    if (response.success) {
      store.dispatch({
        type: Transaction.SET_TRANSACTION,
        payload: {
          ...state,
          response: merchant,
          originalResponse: merchant,
          processing: false,
        },
      });
    } else {
      store.dispatch({
        type: Transaction.SET_TRANSACTION,
        payload: {
          ...state,
          processing: false,
        },
      });
    }
  };

  static GetTransactionBiller = async (state: State.MerchantTransaction) => {
    let merchant = new APIresponse.TransactionBiller();
    let response = new APIresponse.API();
    response = await POST(
      `${ApiService.transaction.getTransactionBiller}categoryId=${state.categoryId}`,
      {
        page: 0,
        size: 100,
      },
      sessionStorage.getItem("*****")
    );

    merchant = response.data?.billerDTOList;
    if (response.success) {
      store.dispatch({
        type: Transaction.SET_TRANSACTION,
        payload: {
          ...state,
          biller: merchant,
          originalBiller: merchant,
          processing: false,
          billerLoaded: true,
        },
      });
    } else {
      store.dispatch({
        type: Transaction.SET_TRANSACTION,
        payload: {
          ...state,
          processing: false,
          billerLoaded: false,
        },
      });
    }
  };

  static GetTransactionProduct = async (state: State.MerchantTransaction) => {
    const merchantDetail = await this.GetLoggedInUser({} as any);
    const response = await POST(
      `${ApiService.transaction.getTransactionProduct}billerId=${state.billerId}&categoryId=${state.categoryId}`,
      {
        page: 0,
        size: 100,
      },
      sessionStorage.getItem("*****")
    );
    const merchant: Array<APIresponse.TransactionProduct> =
      response.data?.productDTOList;
    if (response.success) {
      store.dispatch({
        type: Transaction.SET_TRANSACTION,
        payload: {
          ...state,
          product: merchant,
          originalProduct: merchant,
          processing: false,
          user: merchantDetail,
        },
      });
    } else {
      store.dispatch({
        type: Transaction.SET_TRANSACTION,
        payload: {
          ...state,
          processing: false,
        },
      });
    }
  };

  static MakePayment = async (state: State.MerchantTransaction) => {
    const response = await POST(
      `${ApiService.transaction.makePayment}`,
      state.billerDetails?.name?.toLowerCase().includes("jamb")
        ? {
            uniqueCode: state.uniqueCode?.toString(),
            requestId: state.requestId,
            details: state.details,
          }
        : {
            uniqueCode: state.uniqueCode?.toString(),
            requestId: state.requestId,
            details: {
              ...state.details,
              amount: parseFloat(
                state.details?.amount
                  ?.toString()
                  .replace(",", "")
                  .replace(/\B(?=(\d{3})+(?!\d))/g, "") as any
              ),
            },
          },
      sessionStorage.getItem("*****")
    );
    const merchant = response;
    if (response?.success) {
      store.dispatch({
        type: Transaction.SET_TRANSACTION,
        payload: {
          ...state,
          processing: false,
          message: response.responseMessage,
          isSuccessful: true,
          isPending: false,
          showResult: true,
          title: "Transaction Successful",
          showTransactionPinForm: false,
          details: new APIrequest.Details(),
          lookUpResponse: merchant,
          showElectricityLookUp: false,
          transactionDate: response.transactionDateTime,
          educationProductOption: null,
        },
      });
      Notify(response.responseMessage as string, true);
    } else if (response?.pending) {
      store.dispatch({
        type: Transaction.SET_TRANSACTION,
        payload: {
          ...state,
          processing: false,
          message:
            response.responseMessage ||
            "We couldn't confirm the status of this transaction. Please check your transaction history before retrying.",
          isSuccessful: false,
          isPending: true,
          showResult: true,
          title: "Transaction Pending",
          showTransactionPinForm: false,
          details: new APIrequest.Details(),
          lookUpResponse: merchant,
          educationProductOption: null,
        },
      });
    } else {
      store.dispatch({
        type: Transaction.SET_TRANSACTION,
        payload: {
          ...state,
          processing: false,
          message: response.responseMessage,
          isSuccessful: false,
          isPending: false,
          showResult: true,
          title: "Transaction Failed",
          showTransactionPinForm: false,
          details: new APIrequest.Details(),
          lookUpResponse: merchant,
          educationProductOption: null,
        },
      });
    }
  };

  static LookUp = async (state: State.MerchantTransaction) => {
    let userInfo = await this.userValidation();
    const requestId =
      (((userInfo.firstName?.substring(0, 3).toUpperCase() as string) +
        userInfo.lastName?.substring(0, 3).toUpperCase()) as string) +
      Date.now();

    const response = await POST(
      `${ApiService.transaction.lookUp}`,
      {
        uniqueCode: state.uniqueCode?.toString(),
        requestId: requestId,
        details: {
          ...state.details,
          phoneNumber:
            state.billerDetails?.name?.toLowerCase().includes("smile") &&
            state.details?.phoneNumber,
          amount: parseFloat(
            state.details?.amount
              ?.toString()
              .replace(",", "")
              .replace(/\B(?=(\d{3})+(?!\d))/g, "") as any
          ),
        },
      },
      sessionStorage.getItem("*****")
    );
    const merchant: APIresponse.LookUpResponse = response?.data;

    if (response?.success) {
      const showTransactionInfo = state.billerDetails?.name
        ?.toLowerCase()
        .includes("smile")
        ? true
        : false;
      store.dispatch({
        type: Transaction.SET_TRANSACTION,
        payload: {
          ...state,
          processing: false,
          message: response.responseMessage,
          isSuccessful: true,
          showResult: false,
          details: merchant,
          showTransactionInfo: showTransactionInfo,
          lookUpResponse: merchant,
          showElectricityLookUp: true,
          requestId: response.requestId,
          showEducationPayment: true,
          showCableTvLookUp: true,
          showBettingLookUp: true,
          modalWidth: "40%",
          isLookUp: true,
          uniqueCode: state.uniqueCode,
        },
      });
      Notify(response.responseMessage as string, true);
    } else {
      store.dispatch({
        type: Transaction.SET_TRANSACTION,
        payload: {
          ...state,
          processing: false,
          isLookUp: false,
        },
      });
      Notify(response.responseMessage as string, false);
    }
  };

  static PinVerification = async (state: State.MerchantTransaction) => {
    const response = await POST(
      `${ApiService.pin.verify}`,
      state.transactionPin,
      sessionStorage.getItem("*****")
    );
    if (response.success) {
      store.dispatch({
        type: Transaction.SET_TRANSACTION,
        payload: {
          ...state,
          processing: false,
          pinCorrect: response.data === true ? true : false,
          message:
            response.data === null
              ? response.responseMessage
              : response.data === false
              ? "Incorrect PIN"
              : "PIN verified",
        },
      });
    } else {
      store.dispatch({
        type: Transaction.SET_TRANSACTION,
        payload: {
          ...state,
          processing: false,
          pinCorrect: false,
          message:
            response.data === null ? response.responseMessage : response.data,
        },
      });
    }
  };

  static CreateTransactionPin = async (state: State.MerchantTransaction) => {
    const response = await POST(
      `${ApiService.pin.create}`,
      state.createPin,
      sessionStorage.getItem("*****")
    );
    if (response.success) {
      store.dispatch({
        type: Transaction.SET_TRANSACTION,
        payload: {
          ...state,
          pinCreation: response.data,
          showTransactionPinForm: true,
        },
      });
      Notify(response.responseMessage as string, true);
    } else {
      store.dispatch({
        type: Transaction.SET_TRANSACTION,
        payload: {
          ...state,
          pinCreation: response.data,
        },
      });
      Notify(response.responseMessage as string, false);
    }
  };

  static ChangeTransactionPin = async (state: State.MerchantSettings) => {
    const response = await POST(
      `${ApiService.settings.changeTransactionPin}`,
      state.changePin,
      sessionStorage.getItem("*****")
    );
    if (response.success) {
      store.dispatch({
        type: MerchantSetting.Set_Merchant_KeySettings_State,
        payload: {
          ...state,
          changePin: new APIrequest.ChangeTransactionPin(),
        },
      });
      Notify(response.responseMessage as string, true);
    } else {
      store.dispatch({
        type: MerchantSetting.Set_Merchant_KeySettings_State,
        payload: {
          ...state,
          changePin: new APIrequest.ChangeTransactionPin(),
        },
      });
      Notify(response.responseMessage as string, false);
    }
  };

  static ResetTransactionPin = async (state: State.MerchantSettings) => {
    const response = await POST(
      `${ApiService.settings.resetPin}`,
      {} as any,
      sessionStorage.getItem("*****")
    );
    if (response.success) {
      store.dispatch({
        type: MerchantSetting.Set_Merchant_KeySettings_State,
        payload: {
          ...state,
          changePin: new APIrequest.ChangeTransactionPin(),
        },
      });
      Notify("Pin reset successfully, check your mail for the new pin", true);
    } else {
      store.dispatch({
        type: MerchantSetting.Set_Merchant_KeySettings_State,
        payload: {
          ...state,
          changePin: new APIrequest.ChangeTransactionPin(),
        },
      });
      Notify(response.responseMessage as string, false);
    }
  };

  static FilterProduct = async (
    dispatch: any,
    state: State.MerchantProduct
  ) => {
    const response = await POST(
      `${ApiService.product.productSearch}?download=${state.isDownload}`,
      state.filterRequests,
      sessionStorage.getItem("*****")
    );
    if (response.success) {
      const merchant: Array<APIresponse.MerchantProducts> =
        response.data?.productDTOList;
      let sn = 0;
      merchant?.forEach((element) => {
        sn = sn + 1;
        element.key = sn;
      });
      store.dispatch({
        type: MerchantProducts.Set_Merchant_Product_State,
        payload: {
          ...state,
          response: merchant,
          processing: false,
          showModal: false,
          isDownload: false,
          filterRequests: new APIrequest.FilterProductRequest(),
        },
      });
      Notify(response.responseMessage as string, true);
    } else {
      store.dispatch({
        type: MerchantProducts.Set_Merchant_Product_State,
        payload: {
          ...state,
          processing: false,
        },
      });
      Notify(response.responseMessage as string, false);
    }
  };

  static GetAllBulkAirtime = async (state: State.BulkAirtime) => {
    const response = await POST(
      `${ApiService.bulk.getAllBulk}`,
      {
        page: state.page ? state.page : 0,
        size: state.pageSize ? state.pageSize : 100,
      },
      sessionStorage.getItem("*****")
    );

    const merchant: Array<APIresponse.AllBulkAirtime> =
      response.data?.airtimeBulkDTOList;
    if (response.success) {
      let sn = 0;
      merchant?.forEach((element) => {
        sn = sn + 1;
        element.key = sn;
      });
      store.dispatch({
        type: BulkAirtime.SET_BULK_AIRTIME,
        payload: {
          ...state,
          processing: false,
          response: merchant,
          originalResponse: merchant,
        },
      });
    } else {
      store.dispatch({
        type: BulkAirtime.SET_BULK_AIRTIME,
        payload: {
          ...state,
          processing: false,
        },
      });
    }
  };

  static GetSingleBulkAirtime = async (state: State.BulkAirtime) => {
    const response = await POST(
      `${ApiService.bulk.getSingleAirtimeBulk}${state.bulkId}`,
      {},
      sessionStorage.getItem("*****")
    );
    const merchant: Array<APIresponse.BulkAirtime> =
      response.data?.airtimeBulkItemDTOList;
    if (response.success) {
      let sn = 0;
      merchant?.forEach((element) => {
        sn = sn + 1;
        element.key = sn;
      });
      store.dispatch({
        type: BulkAirtime.SET_BULK_AIRTIME,
        payload: {
          ...state,
          processing: false,
          singleAirtimeBulk: merchant,
          showSingleBulk: true,
        },
      });
    } else {
      store.dispatch({
        type: BulkAirtime.SET_BULK_AIRTIME,
        payload: {
          ...state,
          processing: false,
          showSingleBulk: false,
        },
      });
    }
  };

  static UploadBulk = async (state: State.BulkAirtime) => {
    const response = await POST(
      `${ApiService.bulk.performBulkAirtime}`,
      state.formData,
      sessionStorage.getItem("*****"),
      state.formData
    );
    const bulk: string = response.data?.result;
    if (response.success) {
      this.GetAllBulkAirtime({
        ...state,
        showBulkAirtimeTransaction: false,
        processing: false,
      });
      Notify(bulk as string, true);
    } else {
      store.dispatch({
        type: BulkAirtime.SET_BULK_AIRTIME,
        payload: {
          ...state,
          processing: false,
        },
      });
      Notify(response.responseMessage as string, false);
    }
  };
}
